'use strict';

var angular = require('angular');
require('./filters.js');

module.exports = 'ch.filters';
